<div class="is-btn is-btn__outfill is-disabled" (click)="toggleShowVideo()" >
  Play manual <i class="app-ico-mask app-ico-mask__play"></i>
</div>

<div class="video-popup-bg" *ngIf="showVideo" (click)="toggleShowVideo()" @opacityInOut></div>
<div class="video-popup" *ngIf="showVideo" @scaleInOut>
  <i class="app-ico-mask app-ico-mask__play"></i>
</div>